import { hyphenateHTML } from 'hyphen/de';

const hyphen = () => {
  Array.from(
    document.querySelectorAll(
      'h1,h2,h3,h4,h5,h6,.u-text-h0,.u-text-h1,.u-text-h2,.u-text-h3,.u-text-h4,.u-text-h5,.u-text-h6,.c-tease__image-overlay,.c-card__content,.c-main-nav__link,.c-main-nav__sublink,.c-card__image-overlay,.c-step__title',
    ),
  ).forEach(el => {
    hyphenateHTML(el.innerHTML, { debug: false, minWordLength: 5 }).then(
      result => {
        // eslint-disable-next-line no-param-reassign
        result = result.replace('®', '<sup>®</sup>');
        // eslint-disable-next-line no-param-reassign
        result = result.replace('<sup><sup>®</sup></sup>', '<sup>®</sup>');
        // eslint-disable-next-line no-param-reassign
        el.innerHTML = result;
      },
    );
  });
};

hyphen();
